





















import { Component, Vue, Prop } from "vue-property-decorator";
import { NullableRangeParameter } from "@/domainproject/parameter";

@Component({
  watch: {
    value: function(this: NullableRange, newValue: string) {
      if (this.parameter.$_value != this.value) {
        this.parameter.set(parseFloat(newValue));
        this.inputChanged();
      }
    },
    checked: function(this: NullableRange, checked) {
      this.parameter.setActive(checked);
      this.inputChanged();
    }
  }
})
export default class NullableRange extends Vue {
  @Prop() parameter!: NullableRangeParameter;
  @Prop() label!: string;
  @Prop() color!: string;

  value = this.parameter.$_value || this.parameter.$_initial;
  checked = this.parameter.$_active;

  mousedown = false;
  emitWhenReleased = false;

  inputChanged() {
    if (this.mousedown) {
      this.emitWhenReleased = true;
    } else {
      this.$emit("input");
    }
  }

  releaseMouse() {
    this.mousedown = false;
    if (this.emitWhenReleased) {
      this.$emit("input");
      this.emitWhenReleased = false;
    }
  }

  mounted() {
    document.body.addEventListener("mouseup", this.releaseMouse, false);
  }

  destroyed() {
    document.body.removeEventListener("mouseup", this.releaseMouse, false);
  }
}
